export const POST_COLLECTION_IDENTIFIER = "post";
